import { css } from "@emotion/react";

import { dimensions, colors } from "@styles";

export const wrapper = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 1rem 2rem;

  @media (max-width: ${dimensions.tablet}) {
    justify-content: center;
    padding: 0;
  }
`;

export const bottomBorder = css`
  border-bottom: 1px solid ${colors.grey.lightFamily.normal};
  padding-bottom: 0px;
`;
